<template>
  <application-layout>
    <v-main>
      <v-container>
        <v-form
          ref="createLandingPageForm"
          @submit.prevent="submitLandingPageForm"
        >
          <h1 class="mb-2">Create Landing Page</h1>
          <v-row>
            <v-col cols="12">
              <h2 class="mt-4">SEO</h2>
            </v-col>
            <v-col cols="12" sm="4">
              <app-input
                data-testid="landing-page-create-title-input"
                class="landing-page-create-title-input"
                label="Page Title"
                v-model.trim="landingPage.meta_title"
                :type="'text'"
                :rules="{ required: true }"
                :useValidation="true"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <app-input
                data-testid="landing-page-create-description-input"
                class="landing-page-create-description-input"
                label="Meta Description"
                :type="'text'"
                v-model.trim="landingPage.meta_description"
                :rules="{ required: true }"
                :useValidation="true"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <app-input
                data-testid="landing-page-create-keywords-input"
                class="landing-page-create-keywords-input"
                label="Meta Keywords"
                :type="'text'"
                v-model.trim="landingPage.meta_keywords"
              />
            </v-col>
          </v-row>
          <v-row  class="mb-4">
            <v-col cols="12">
              <h2>Content</h2>
            </v-col>
            <v-col cols="12" sm="4">
              <app-input
                data-testid="landing-page-create-header-input"
                class="landing-page-create-header-input"
                label="Page Header"
                :type="'text'"
                v-model.trim="landingPage.page_header"
              />
            </v-col>
            <v-col cols="12">
              <froala
                data-testid="landing-page-create-froala-textarea"
                class="landing-page-create-froala-textarea"
                :tag="'textarea'"
                :config="froalaConfig"
                v-model.trim="landingPage.content"
                id="content"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h2>Custom Code</h2>
            </v-col>
            <v-col cols="12" sm="4">
              <v-textarea
                data-testid="landing-page-create-markup-head-textarea"
                class="landing-page-create-markup-head-textarea"
                label="Custom Markup (head)"
                filled
                hint="Code in this box will be injected right before the closing head tag on this page"
                v-model.trim="landingPage.custom_markup_head"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-textarea
                data-testid="landing-page-create-markup-body-textarea"
                class="landing-page-create-markup-body-textarea"
                label="Custom Markup (body)"
                filled
                hint="Code in this box will be injected right before the closing body tag on this page"
                v-model.trim="landingPage.custom_markup_body"
                clearable
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-textarea
                data-testid="landing-page-create-css-textarea"
                class="landing-page-create-css-textarea"
                label="Custom CSS"
                filled
                v-model.trim="landingPage.custom_css"
                clearable
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn
                data-testid="landing-page-create-cancel-btn"
                class="landing-page-create-cancel-btn mr-3 ml-0"
                @click="() => { this.$router.back(); }"
                color="error"
              >
                Cancel
              </v-btn>
              <v-btn
                data-testid="landing-page-create-save-btn"
                class="landing-page-create-save-btn"
                color="primary"
                type="submit"
                :loading="loadingState.includes('creating landing page')"
              >
                Save
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";

export default {
  data() {
    return {};
  },
  computed: {
    loadingState() {
      return this.$store.state.landingPage.loadingState;
    },
    landingPage: {
      get() {
        return this.$store.state.landingPage.currentLandingPage;
      },
      set(newValue) {
        return this.$store.commit("setCurrentLandingPageData", newValue);
      }
    },
    froalaConfig() {
      return {
        ...this.$store.state.app.froalaConfig,
        theme: this.$vuetify.theme.dark ? "dark" : null,
        requestHeaders: {
          Authorization: this.$store.state.auth.access_token
        }
      };
    }
  },
  methods: {
    submitLandingPageForm() {
      if (this.$refs.createLandingPageForm.validate()) {
        this.$store.dispatch("createLandingPage");
      }
    }
  },
  components: {
    ApplicationLayout
  },

  created() {
    this.$store.commit("resetCurrentLandingPage");
  }
};
</script>
